import { Component, Injector, Input, OnInit } from '@angular/core';
import { ListData } from '@fi-app/components/items-list/list-data.service';
import { ItemsListContainerBase } from '@fi-app/components/items-list-container-base';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { BillingService } from '../../billing.service';
import { BillingUnitListData } from '../billing-unit-list-data';
import { CentralBillingUnitModuleModel } from '../../billing-central/central-billing-unit-module.model';
import { DropdownSettingsModelV2 } from '@fi-shared/dropdown';
import { IBillingModuleModel } from '@fi-app/billing/billing-header/billing-header.component';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';
import { ILightWeightObject } from '@fi-shared/models';

@Component({
    selector: 'fi-billing-unit-list',
    template: `
        <fi-select-search
            [items]="unitsDropdownSettings.dataSet$ | async"
            [(ngModel)]="selectedUnitId"
            (ngModelChange)="onSelectedUnitChange($event)"
            class="UnitsList"
            [required]="true"
            [filterBy]="unitsDropdownSettings.filterBy"
            [displayValue]="unitsDropdownSettings.dataTextField"
            [matOptionValueProperty]="unitsDropdownSettings.dataValueField"
        >
        </fi-select-search>
        <fi-items-list [settings]="ListData" class="billing-unit-list"></fi-items-list>
    `,
    styleUrls: ['./billing-unit-list.component.scss'],
    standalone: false,
})
export class BillingUnitListComponent
    extends ItemsListContainerBase<ListData<CentralBillingUnitModuleModel>>
    implements OnInit
{
    @Input() billingModuleModel: IBillingModuleModel;
    unitsDropdownSettings = new DropdownSettingsModelV2<ILightWeightObject>({
        orderBy: 'Id',
    });
    selectedUnitId;

    constructor(
        private fiLoadingService: LoadingService,
        private billingService: BillingService,
        private injector: Injector,
        private userDataService: FiUserDataService,
    ) {
        super();
    }

    ngOnInit(): void {
        this.selectedUnitId = this.userDataService.userData.BusinessUnitId;

        super.onInit(() => new BillingUnitListData(this.injector), {
            noLocalSearch: true,
            showDelete: false,
        });

        setTimeout(() => (this.billingModuleModel.ListData = this.ListData));
        this.setUnitsDataSet();
    }

    private setUnitsDataSet() {
        this.unitsDropdownSettings.setDataSet(this.userDataService.getUserBusinessUnits());
    }

    onSelectedUnitChange($event) {
        this.selectedUnitId = $event;
        this.LoadItems();
    }

    protected LoadItems(): Promise<void> {
        return this.fiLoadingService.trackPromise(
            this.billingService.GetUnitBillingModules(this.selectedUnitId).then((items) => {
                this.ListData.clearData();
                this.ListData.appendData(items);
            }),
        );
    }
}
